import { Link } from "react-router-dom";
import { BRAND } from "@/lib/config";
import { Phone } from "lucide-react";

export const Header = () => {
  return (
    <header className="sticky top-0 z-40 glass-panel">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <img src="/logo.jpeg" alt="Bawajii Travels & Infra" className="h-12 w-12 rounded-full object-cover ring-1 ring-[color:var(--brand-forest)]/20" />
          <div className="leading-tight">
            <div className="font-display text-lg text-[color:var(--brand-ink)]">{BRAND.name}</div>
            <div className="text-xs text-[color:var(--brand-muted)] tracking-wide uppercase">Travels &amp; Infra · Since 2010</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[color:var(--brand-ink)]/80">
          <a href="#about" data-testid="nav-about" className="hover:text-[color:var(--brand-forest)] transition-colors duration-200">About</a>
          <a href="#services" data-testid="nav-services" className="hover:text-[color:var(--brand-forest)] transition-colors duration-200">Services</a>
          <a href="#fleet" data-testid="nav-fleet" className="hover:text-[color:var(--brand-forest)] transition-colors duration-200">Fleet</a>
          <a href="#routes" data-testid="nav-routes" className="hover:text-[color:var(--brand-forest)] transition-colors duration-200">Routes</a>
          <a href="#contact" data-testid="nav-contact" className="hover:text-[color:var(--brand-forest)] transition-colors duration-200">Contact</a>
        </nav>

        <a
          href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
          data-testid="header-call-btn"
          className="hidden sm:flex items-center gap-2 rounded-full border border-[color:var(--brand-forest)] px-4 py-2 text-sm font-semibold text-[color:var(--brand-forest)] hover:bg-[color:var(--brand-forest)] hover:text-white transition-colors duration-300"
        >
          <Phone className="h-4 w-4" />
          {BRAND.phone}
        </a>
      </div>
    </header>
  );
};

export default Header;
